import MainLogo from '@components/Logo/MainLogo'
import { ProgressSpinner } from 'primereact/progressspinner'

/**
 * Full-page or inline loading indicator, optionally showing the app logo above the spinner.
 *
 * @component
 * @param {Object} props
 * @param {Boolean} [props.full] - Whether to render as a full-page loader with the app logo.
 * @returns {JSX.Element}
 */
export default function Loader({ full }) {
  const classname = ['loader-container']

  full && classname.push('full')

  return (
    <section className={classname.join(' ')}>
      <div className="loader-container-content">
        {full && (
          <div className="loader-container-logo">
            <MainLogo />
          </div>
        )}

        <div className="loader-container-spinner">
          <ProgressSpinner strokeWidth={6} />
        </div>
      </div>
    </section>
  )
}
